<template>
	<!-- begin sidebar nav -->
	<ul class="nav" v-if="menus">
		<li class="nav-header  " style="border-bottom: 0.5px solid rgb(64, 71, 77) !important;"> Módulos Generales </li>
		<template v-for="menu in menus">
			<sidebar-nav-list ref="sidebarNavList" v-bind:menu="menu" v-bind:scrollTop="scrollTop"
				v-bind:key="menu.path" v-bind:status="menu.status" v-on:collapse-other="handleCollapseOther(menu)"
				v-on:showFloatSubmenu="handleShowFloatSubmenu" v-on:hideFloatSubmenu="handleHideFloatSubmenu">
			</sidebar-nav-list>
		</template>
		<!-- begin sidebar minify button -->
		<li><a href="javascript:;" class="sidebar-minify-btn" v-on:click="handleSidebarMinify()"><i
					class="fa fa-angle-double-left"></i></a></li>
		<!-- end sidebar minify button -->
	</ul>
	<!-- end sidebar nav -->
</template>

<script>
	import SidebarMenu from './SidebarMenu.vue'
	import SidebarNavList from './SidebarNavList.vue'
	import PageOptions from '../../config/PageOptions.vue'

	export default {
		name: 'SidebarNav',
		props: ['scrollTop'],
		components: {
			SidebarNavList
		},
		mounted() {
			this.verModulos();
		},
		data() {
			return {
				menus: null,
				pageOptions: PageOptions,

			}
		},
		methods: {
			handleShowFloatSubmenu: function (menu, offset) {
				this.$emit('showFloatSubmenu', menu, offset);
			},
			handleHideFloatSubmenu: function () {
				this.$emit('hideFloatSubmenu');
			},
			handleCollapseOther: function (menu) {
				for (var i = 0; i < this.menus.length; i++) {
					this.$refs.sidebarNavList[i].collapse(menu);
				}
			},
			handleSidebarMinify: function () {
				this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
			},
			verModulos() {
				let men1 = [{
						path: '/bienvenido',
						icon: 'fa fa-th',
						title: 'Bienvenido'
					},
					//  { path: '/emisores', icon: 'fa fa-industry', title: 'Emisores' },
					{
						path: '/personal',
						icon: 'fa fa-users',
						title: 'Personal'
					},
					{
						path: '/links',
						icon: 'fa fa-link',
						title: 'Links'
					},
					{
						path: '/comisiones',
						icon: 'fa fa-list',
						title: 'Comisiones',
						label: '',
						children: [{
								path: '/comisiones/chip',
								title: 'Chips'
							},
							{
								path: '/comisiones/equipo',
								title: 'Equipos'
							},
						]
					},
					{
						path: '/entregas',
						icon: 'fa fa-list',
						title: 'Entregas',
						label: '',
						children: [{
								path: '/entregas/chip',
								title: 'Chips'
							},
							{
								path: '/entregas/equipo',
								title: 'Equipos'
							},
						]
					},
					{
						path: '/reporte',
						icon: 'fa fa-list',
						title: 'Reportes',
						label: '',
						children: [
							{
							path: '/reporte/pago-personal',
							title: 'Pago Personal'
						},
							{
							path: '/reporte/pago-responsable',
							title: 'Pago Responsables'
						},
						 ]
					},
				]
				let men2 = [{
					path: '/inicio',
					icon: 'fa fa-th',
					title: 'Bienvenido'
				}, 
				
				
				];
				let men3 = [{
						path: '/bienvenido',
						icon: 'fa fa-th',
						title: 'Bienvenido'
					},
					
					{
						path: '/reporte',
						icon: 'fa fa-list',
						title: 'Reportes',
						label: '',
						children: [{
							path: '/reporte/pago-personal',
							title: 'Pago Personal'
						}, ]
					},
				];

				if (this.$store.state.usuario.tipo == '2') {
					this.menus = [...men1];
				} else if(this.$store.state.usuario.tipo > '2') {
					this.menus = [...men3];
				}else{
					this.menus = [...men2];
				}



			}
		}
	}
</script>